import {
  REQUEST_REGISTERS,
  FETCH_REGISTERS_SUCCESS,
  FETCH_REGISTERS_FAILRE,
  REQUEST_REGISTER_SESSIONS,
  REQUEST_REGISTER_SESSIONS_DATE,
  FETCH_REGISTER_SESSIONS_SUCCESS,
  FETCH_REGISTER_SESSIONS_FAILURE,
  VERIFY_REGISTER,

  REQUEST_POS_ORDERS,
  FETCH_POS_ORDERS_SUCCESS,
  FETCH_POS_ORDERS_FAILURE,

  REQUEST_POS_ORDER_DETAIL,
  FETCH_POS_ORDER_DETAIL_SUCCESS,
  FETCH_POS_ORDER_DETAIL_FAILURE,

  REQUEST_VOID_POS_ORDER,
  VOID_POS_ORDER_SUCCESS,
  VOID_POS_ORDER_FAILURE,

  REQUEST_POS_CREDITS,
  FETCH_POS_CREDITS_SUCCESS,
  FETCH_POS_CREDITS_FAILURE,

  REQUEST_POS_CREDIT_DETAIL,
  FETCH_POS_CREDIT_DETAIL_SUCCESS,
  FETCH_POS_CREDIT_DETAIL_FAILURE,

  REQUEST_EDIT_POS_PAYMENT,
  EDIT_POS_PAYMENT_SUCCESS,
  EDIT_POS_PAYMENT_FAILURE,
  FETCH_POS_HOLDS_SUCCESS,
  FETCH_POS_HOLDS_DETAILS_SUCCESS,
} from '../actions/type';

const INITIAL_STATE = {
  all: null,
  isLoading: true,
  error: null,
  registers: [],
  registersIsLoading: false,
  registersError: null,

  sessions: [],
  sessionsIsLoading: false,
  sessionsError: null,

  currentSalesOrder: null,
  currentPosOrderDetail: null,
  detailIsLoading: false,
  detailError: null,

  currentPosCreditDetail: null,
  creditDetailIsLoading: false,
  creditDetailError: null,

  editingPosPayment: false,
  editedPosPayment: false,
  editPosPaymentError: null,

  posHolds: [],
  posHoldsOderDetail: null,
  FromDate: new Date(),
  ToDate: new Date(),
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // Fetch registers
    case FETCH_POS_HOLDS_DETAILS_SUCCESS:
      return { ...state, posHoldsOderDetail: action.payload };
    case FETCH_POS_HOLDS_SUCCESS:
      return { ...state, posHolds: action.payload };
    case REQUEST_REGISTERS:
      return { ...state, registersIsLoading: true, registers: [], registersError: null };
    case FETCH_REGISTERS_SUCCESS:
      return { ...state, registersIsLoading: false, registers: action.payload.data };
    case FETCH_REGISTERS_FAILRE:
      return { ...state, registersIsLoading: false, registersError: action.payload.data };

    // Fetch sessions
    case REQUEST_REGISTER_SESSIONS:
      return { ...state, sessionsIsLoading: true, sessions: [], sessionsError: null };
    case REQUEST_REGISTER_SESSIONS_DATE:
      return { ...state, sessionsIsLoading: true, sessions: [], sessionsError: null };
    case FETCH_REGISTER_SESSIONS_SUCCESS:
      const data = {};
      if (action.payload.fromDate) {
        data.fromDate = action.payload.fromDate;
        data.toDate = action.payload.toDate;
        data.sessions = action.payload.response.data;
        data.registerID = action.payload.registerID;
      } else {
        data.sessions = action.payload.data;
      }
      return { ...state, sessionsIsLoading: false, ...data };
    case FETCH_REGISTER_SESSIONS_FAILURE:
      return { ...state, sessionsIsLoading: false, sessionsError: action.payload.data };
    case VERIFY_REGISTER:
      return { ...state, sessionsIsLoading: true, sessions: [], sessionsError: null };

    // Fetch POS orders
    case REQUEST_POS_ORDERS:
        return { ...state, error: null, isLoading: true };
    case FETCH_POS_ORDERS_SUCCESS:
      return { ...state, all: action.payload.data, error: null, isLoading: false };
    case FETCH_POS_ORDERS_FAILURE:
      const error = action.payload || { message: action.payload.message };
      return { ...state, all: [], error: error, isLoading: false };
    case REQUEST_POS_ORDER_DETAIL:
      return { ...state, detailError: null, detailIsLoading: true, currentPosOrderDetail: null };
    case FETCH_POS_ORDER_DETAIL_SUCCESS:// return list of posts and make loading = false
      return { ...state, currentPosOrderDetail: action.payload, detailError: null, detailIsLoading: false };
    case FETCH_POS_ORDER_DETAIL_FAILURE:// return error and make loading = false
      const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
      return { ...state, all: [], detailError: detailError, detailIsLoading: false };
    case REQUEST_VOID_POS_ORDER:
      return {...state, error: null, isLoading: true };
    case VOID_POS_ORDER_SUCCESS:
        return { ...state, isLoading: false };
    case VOID_POS_ORDER_FAILURE:
      const voidError = action.payload.data || { message: action.payload.message };//2nd one is network or server down errors
      alert(JSON.stringify(voidError));
      return { ...state, error: voidError, isLoading: false };

    // Fetch POS credit
    case REQUEST_POS_CREDITS:
      return { ...state, error: null, isLoading: true };
    case FETCH_POS_CREDITS_SUCCESS:
      return {
        ...state, all: action.payload.data, error: null, isLoading: false,
      };
    case FETCH_POS_CREDITS_FAILURE: {
      const creditError = action.payload || { message: action.payload.message };
      return {
        ...state, all: [], error: creditError, isLoading: false,
      };
    }
    case REQUEST_POS_CREDIT_DETAIL:
      return {
        ...state, detailError: null, creditDetailIsLoading: true, currentPosOrderDetail: null,
      };
    case FETCH_POS_CREDIT_DETAIL_SUCCESS:
      return {
        ...state, currentPosCreditDetail: action.payload, creditDetailError: null, creditDetailIsLoading: false,
      };
    case FETCH_POS_CREDIT_DETAIL_FAILURE: {
      const creditDetailError = action.payload || { message: action.payload.message };
      return {
        ...state, all: [], creditDetailError: creditDetailError, creditDetailIsLoading: false,
      };
    }

    // edit POS payment
    case REQUEST_EDIT_POS_PAYMENT:
      return {
        ...state,
        editingPosPayment: true,
        editedPosPayment: false,
        editPosPaymentError: null,
      };
    case EDIT_POS_PAYMENT_SUCCESS:
      return {
        ...state,
        editingPosPayment: false,
        editedPosPayment: true,
        editPosPaymentError: null,
      };
    case EDIT_POS_PAYMENT_FAILURE:
      const editPosPaymentError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(editPosPaymentError));
      return {
        ...state,
        editingPosPayment: false,
        editedPosPayment: false,
        editPosPaymentError,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/pos_reducer.jsx